import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export var tabsTheme = function tabsTheme(baseTheme) {
  return _objectSpread({}, tabListTheme(baseTheme), tabPanelTheme(baseTheme), baseTheme);
};
export var tabTheme = function tabTheme(baseTheme) {
  return _objectSpread({
    Tab_backgroundColor_selected: baseTheme.backgroundColor_theme_selected,
    Tab_borderColor_focus: baseTheme.borderColor_theme_focus,
    Tab_borderWidth_focus: 1,
    Tab_color: baseTheme.color_gray_80,
    Tab_color_selected: baseTheme.color_theme_70,
    Tab_color_selectedHover: baseTheme.color_theme,
    TabIndicator_thickness: 2
  }, baseTheme);
};
export var tabListTheme = function tabListTheme(baseTheme) {
  return _objectSpread({
    TabList_gutterHorizontal: baseTheme.space_inline_md,
    TabList_gutterVertical: baseTheme.space_stack_sm,
    TabListArrow_color: baseTheme.color_gray_80,
    TabListArrow_color_hover: baseTheme.color_theme,
    TabListOverflowContainer_boxShadowColor: baseTheme.color_white
  }, baseTheme);
};
export var tabPanelTheme = function tabPanelTheme(baseTheme) {
  return _objectSpread({
    // This TabList theme variable is defined here because the border is visually
    // associated with TabList, but for styling reasons, it is applied to TabPanel
    TabList_border: "1px solid " + baseTheme.borderColor,
    TabPanel_gap: baseTheme.space_inline_md
  }, baseTheme);
};